module.exports = __webpack_public_path__ + "assets/img/dailyTask-bottom-left.204fbe38.png";